export default __webpack_public_path__ + "static/arithmenillustrations-02-874f59b273678ebbfacc081b26806a64.png";